// extracted by mini-css-extract-plugin
module.exports = {"container":"_2-eakKM0sqv336-aBgCQXw"};